<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
        lg="12"
      >
        <base-card>
          <v-card-text class>
            <div>
              <h6 class="text-caption text--disabled tracking-widest">
                Projects
              </h6>

              <v-list-item
                v-for="instance in instances"
                :key="instance.extId"
                class="pa-0"
              >
                <v-list-item-avatar>
                  <v-icon>
                    mdi-cloud
                  </v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="text-body-2 font-weight-medium"
                    v-text="instance.extId"
                  />
                  <v-list-item-subtitle v-text="instance.adminUsername" />
                </v-list-item-content>

                <v-list-item-action>
                  <!--div class="flex-1">
                    <div class="d-flex justify-space-between">
                      <p class="ma-0">
                        Ingest Completion
                      </p>
                      <p class="ma-0">
                        40%
                      </p>
                    </div>
                    <v-progress-linear value="15" color="primary" />
                  </div-->
                  <v-btn
                    outlined
                    small
                    :loading="instance.loading"
                    :disabled="instance.loading"
                    class="m-l-10"
                    @click="exportXLS(instance)"
                  >
                    <i class="mdi mdi-download p-r-5" />
                    Export
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </div>
          </v-card-text>
        </base-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { processInstance } from '@/store/converters'

  export default {
    name: 'Instances',
    metaInfo: {
      title: 'Instances',
    },
    data () {
      return {
        instances: [],
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
    },
    watch: {
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.$store.commit('setPageLoader')

        const params = {
        }
        const instancesReq = this.$store.dispatch('instances', params)

        Promise.all([instancesReq])
          .then((result) => {
            const instances = result[0] || []
            for (let i = 0; i < instances.length; i += 1) {
              const instance = processInstance(instances[i])
              this.instances.push(instance)
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      exportXLS (instance) {
        instance.loading = true

        const params = {
          instance_id: instance.id,
        }

        this.$store.dispatch('getAssetReport', params)
          .then((response) => {
            const blob = new Blob([response.data], { type: response.data.type })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = instance.extId + ' Assets'
            link.click()
            URL.revokeObjectURL(link.href)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          // eslint-disable-next-line no-return-assign
          .finally(() => instance.loading = false)
      },
    },
  }
</script>
